import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../style/legacy/ConferenceNav.css'; // Custom styles
import AEGLogo from '../../assets/images/logos/AEG/AEG logo.jpg';

const ConferenceNav = () => {
  const [showNav, setShowNav] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const prevScrollY = useRef(0);
  const location = useLocation();
  const [isHighlighted, setIsHighlighted] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsHighlighted(false);
    }, 5000);

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setShowNav(currentScrollY <= 100 || currentScrollY <= prevScrollY.current);
      if (isMobileMenuOpen && currentScrollY > prevScrollY.current + 10) {
        setIsMobileMenuOpen(false);
      }
      prevScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobileMenuOpen]);
  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [isConferenceSubOpen, setIsConferenceSubOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) setIsConferenceSubOpen(false); // Reset sub-menu when closing main menu
  };

  const toggleConferenceSub = (e) => {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      setIsConferenceSubOpen(!isConferenceSubOpen);
    }
  };



  return (
    <div className=''>
      <header
        className={`fixed top-0 w-full z-50 bg-white shadow-md transition-all duration-300 ease-in-out ${showNav ? 'translate-y-0' : '-translate-y-full'}`}
      >
        <nav className='w-full'>
          <div className='flex items-center justify-between px-5 lg:px-20 py-0 bg-white text-black max-w-full'>
            <Link to='/' className='flex-shrink-0'>
              <img
                src={AEGLogo}
                alt='Assurance Education Group (AEG Research) Logo - Bhopal'
                className='h-16 w-32 sm:h-20 sm:w-40 lg:h-24 lg:w-48 rounded-2xl ml-0 sm:ml-12'
              />
            </Link>

            <button
              className='lg:hidden text-2xl text-black bg-transparent border-none cursor-pointer hover:text-orange-400 transition-colors duration-300'
              onClick={toggleMobileMenu}
            >
              &#9776;
            </button>

              <ul
                className={`list-none lg:flex lg:items-center lg:gap-6 transition-all duration-300 ease-in-out ${
                  isMobileMenuOpen
                    ? 'flex flex-col absolute top-full left-0 right-0 bg-white shadow-lg border-t p-4 text-black gap-4 w-full'
                    : 'hidden lg:flex'
                }`}
              >
              {/* Home button with conditional behavior */}
              <li>
                {location.pathname === '/' ? (
                  <button 
                    onClick={() => { scrollToTop(); setIsMobileMenuOpen(false); }}
                    className='text-base text-black bg-transparent border-none cursor-pointer px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto flex items-center justify-start lg:justify-start'
                  >
                    Home
                  </button>
                ) : (
                  <Link to='/conference-home' onClick={() => setIsMobileMenuOpen(false)}>
                    <button className='text-base text-black bg-transparent border-none cursor-pointer px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto flex items-center justify-start lg:justify-start'>
                      Home
                    </button>
                  </Link>
                )}
              </li>

              <li className={`relative group ${isConferenceSubOpen ? 'mobile-sub-open' : ''}`}>
                <button 
                  className='text-base text-black bg-transparent border-none cursor-pointer px-4 py-2 transition-all duration-300 hover:bg-orange-400 lg:group-hover:bg-orange-400 lg:group-hover:text-white rounded font-medium w-full lg:w-auto flex items-center justify-start lg:justify-start gap-1' 
                  onClick={toggleConferenceSub}
                >
                  <div className='flex items-center gap-1 relative'>
                    Conference
                    {/* <span className='bg-[#ff4d4d] text-white text-[10px] font-bold px-1.5 py-0.5 rounded leading-tight ml-1'>
                      New
                    </span> */}
                  </div>
                  <span className='lg:hidden'>
                    {isConferenceSubOpen ? '−' : '+'}
                  </span>
                </button>
                
                <div className={`dropdown-list lg:absolute lg:top-full lg:-right-32 lg:z-100 lg:pt-4 transition-all duration-300 ${isConferenceSubOpen ? 'show-mobile max-h-[600px] opacity-100 block' : 'max-h-0 lg:max-h-none opacity-0 lg:opacity-100 lg:hidden lg:group-hover:block'}`}>
                  <div className={`dropdown-container ${isMobileMenuOpen ? 'bg-gray-50 shadow-md rounded-xl my-2 border border-gray-200 p-3' : ''}`}>
                    <div className={isMobileMenuOpen ? 'flex flex-col gap-3' : 'cards-section'}>
                      <Link
                        to='/upcoming-conference'
                        className={isMobileMenuOpen ? 'flex flex-row items-center justify-start gap-3 p-3 pl-6 border-b border-gray-100 w-full text-black hover:bg-orange-400 hover:text-white transition-all duration-200' : 'menu-item'}
                        onClick={() => { setIsMobileMenuOpen(false); setIsConferenceSubOpen(false); }}
                      >
                        <i className={`fas fa-calendar-alt ${isMobileMenuOpen ? '' : ''}`}></i>
                        <span className={isMobileMenuOpen ? 'font-semibold' : ''}>Upcoming Conferences</span>
                      </Link>
                      <Link
                        to='/webinar'
                        className={isMobileMenuOpen ? 'flex flex-row items-center justify-start gap-3 p-3 pl-6 border-b border-gray-100 w-full text-black hover:bg-orange-400 hover:text-white transition-all duration-200' : 'menu-item'}
                        onClick={() => { setIsMobileMenuOpen(false); setIsConferenceSubOpen(false); }}
                      >
                        <i className={`fas fa-video ${isMobileMenuOpen ? '' : ''}`}></i>
                        <span className={isMobileMenuOpen ? 'font-semibold' : ''}>Webinars</span>
                      </Link>
                      <Link
                        to='/conference-proceding'
                        className={isMobileMenuOpen ? 'flex flex-row items-center justify-start gap-3 p-3 pl-6 border-b border-gray-100 w-full text-black hover:bg-orange-400 hover:text-white transition-all duration-200' : 'menu-item'}
                        onClick={() => { setIsMobileMenuOpen(false); setIsConferenceSubOpen(false); }}
                      >
                        <i className={`fas fa-calendar-check ${isMobileMenuOpen ? '' : ''}`}></i>
                        <span className={isMobileMenuOpen ? 'font-semibold' : ''}>Past Conferences</span>
                      </Link>
                      <Link
                        to='/conference-gallery'
                        className={isMobileMenuOpen ? 'flex flex-row items-center justify-start gap-3 p-3 pl-6 w-full text-black hover:bg-orange-400 hover:text-white transition-all duration-200' : 'menu-item'}
                        onClick={() => { setIsMobileMenuOpen(false); setIsConferenceSubOpen(false); }}
                      >
                        <i className={`fas fa-photo-video ${isMobileMenuOpen ? '' : ''}`}></i>
                        <span className={isMobileMenuOpen ? 'font-semibold' : ''}>Conference Videos & Galleries</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <Link to='/contact-form' onClick={() => setIsMobileMenuOpen(false)}>
                  <button className='text-base text-black bg-transparent border-none cursor-pointer px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto flex items-center justify-start lg:justify-start'>
                    Contact us
                  </button>
                </Link>
              </li>

              {/* Back to ResearchLens button with highlight effect for mobile */}
              {isMobileMenuOpen && (
                <li>
                  <Link to='/' onClick={() => setIsMobileMenuOpen(false)}>
                    <button
                      className={`bg-blue-600 text-white px-6 py-2 rounded-full font-bold shadow-lg transform transition-all duration-300 w-full hover:scale-105 ${
                        isHighlighted ? 'animate-pulse' : ''
                      }`}
                    >
                      Back to ResearchLens
                    </button>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </header>

      {/* Uncommented sections */}
      {/* <div ref={HomeRef} id="home">
        <Slider />
      </div>

      <div ref={aboutRef} id="about">
        <About />
      </div>

      <div ref={achievementsRef} id="achievements">
        <Achievements />
      </div>
      <Clients />
      <div ref={contactRef} id="contact">
        <ContactForm />
      </div> */}

      {/* <Hero /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default ConferenceNav;
